export default __webpack_public_path__ + "static/media/moreInfo.6712c711.svg";